// メールテンプレート詳細
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import axios from '../../../axios';
import { handleBrowserBack } from '../../../BrowserBack';
import { maintenance_type } from '../../../Const';
import Maintenance from '../../../molecules/Maintenance';
import LoadingModal from '../../../molecules/LoadingModal';
import StaffNavbar from '../../../molecules/StaffNavbar';

interface Template {
  id: string;
  ja_name: string;
  subject: string;
  body: string;
  type: string;
  start_date: string;
  end_date: string;
}

const MailTemplateDetail = () => {
  // ローディング画面表示状態
  const [is_loading, setIsLoading] = useState(true);
  const [template, setTemplate] = useState<Template>();
  const url_params = new URLSearchParams(document.location.search.substring(1));
  const mail_id = url_params.get('mail_id');

  // グローバルナビゲーション表示用
  const [role, setRole] = useState('');
  const [has_loan_aproval_system, setHasLoanAprovalSystem] = useState(false);
  // 組織区分コードの取得
  const node = document.getElementById('mail-template-detail');

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
    // 表示するメールテンプレートの取得
    getMailTempalte();
    // グローバルナビゲーション表示用
    setUserRole();
  }, []);

  // 選択されたメールテンプレートを取得し表示する
  const getMailTempalte = async () => {
    try {
      const response = await axios.get(`${location.origin}${process.env.MIX_MOCK_URL}/api/get_mail_template`, {
        params: {
          mail_id: mail_id,
        },
      });
      if (response.data.result) {
        setTemplate(response.data.template);
      } else {
        console.error(response.data.message);
        alert(response.data.message);
      }
    } catch (error) {
      console.error(error.response.data.message);
      alert(error.response.data.message);
    }
    setIsLoading(false);
  };

  // ロールを設定する
  const setUserRole = () => {
    if (node === null) {
      // nodeが正しく取得できない場合は空文字とする
      setRole('');
      setHasLoanAprovalSystem(false);
      return;
    }

    // ロール名をセット
    setRole(node.dataset.role as string);

    // 融資稟議システム導入済みフラグをセット
    if ((node.dataset.has_loan_aproval_system as string) === '1') {
      setHasLoanAprovalSystem(true);
    } else {
      setHasLoanAprovalSystem(false);
    }
  };

  return (
    <>
      <StaffNavbar user_role={role} has_loan_aproval_system={has_loan_aproval_system} />
      <Maintenance active={maintenance_type.mail_templates}>
        <div className="page-title">メールテンプレート詳細</div>
        {typeof template === 'object' ? (
          <>
            <table className="detail_table">
              <tbody>
                <tr>
                  <th>JA名</th>
                  <td>{template.ja_name}</td>
                </tr>
                <tr>
                  <th>種別</th>
                  <td>{template.type}</td>
                </tr>
                <tr>
                  <th>タイトル</th>
                  <td>{template.subject}</td>
                </tr>
                <tr>
                  <th>本文</th>
                  <td>{template.body}</td>
                </tr>
                <tr>
                  <th>開始日</th>
                  <td>{template.start_date}</td>
                </tr>
                <tr>
                  <th>終了日</th>
                  <td>{template.end_date}</td>
                </tr>
              </tbody>
            </table>
            <div className="footer-btn">
              <a
                className="btn btn-mini btn-outline-success btn-text-color"
                href={`${location.origin}${process.env.MIX_MOCK_URL}/maintenance/mail_template`}
              >
                戻る
              </a>
              <a
                className="btn btn-mini btn-success"
                href={`${location.origin}${process.env.MIX_MOCK_URL}/maintenance/mail_template_edit?mail_id=${template?.id}`}
              >
                編集
              </a>
            </div>
          </>
        ) : (
          <></>
        )}
        <LoadingModal show={is_loading} />
      </Maintenance>
    </>
  );
};

if (document.getElementById('mail-template-detail')) {
  render(<MailTemplateDetail />, document.getElementById('mail-template-detail'));
}
